/* global _cookieDomain_ */

var StorageService = (function StorageService () {
    'use strict';

    return {
        localStorage: {
            getItem: getItemFromLocalStorage,
            setItem: setItemInLocalStorage,
            remove: removeItemFromLocalStorage
        },
        sessionStorage: {
            getItem: getItemFromSessionStorage,
            setItem: setItemInSessionStorage,
            remove: removeItemFromSessionStorage
        },
        cookie: {
            setCookie: setCookie,
            getCookie: getCookie,
            deleteCookie: deleteCookie
        }
    };


    /* localStorage */
    function getItemFromLocalStorage (key){
        key.toString();

        return localStorage.getItem(key);
    }

    function setItemInLocalStorage (key, value) {
        key = key.toString();

        if (key && value && 'string' === typeof key){
            localStorage.setItem(key, value);
        }
    }

    function removeItemFromLocalStorage (key) {
        localStorage.removeItem(key);
    }


    /* sessionStorage */
    function getItemFromSessionStorage (key) {
        key = key.toString();

        return sessionStorage.getItem(key);
    }

    function setItemInSessionStorage (key, value) {
        if (key && value && 'string' === typeof key){
            sessionStorage.setItem(key, value);
        }
    }

    function removeItemFromSessionStorage (key) {
        sessionStorage.removeItem(key);
    }

    function setCookie (c_name, value, exdays, dontSetDomain) {

        var domain = _cookieDomain_,
            exdate = new Date(),
            c_value;

        if ('undefined' != typeof (dontSetDomain) && true === dontSetDomain) {
            domain = '';
        }

        exdays = exdays || 1;
        exdate.setDate(exdate.getDate() + exdays);
        c_value = escape(value) + ((null == exdays) ? '' : '; ' + domain + '; path=/; SameSite=None; secure; expires=' + exdate.toUTCString());

        document.cookie = c_name + '=' + c_value;
    }

    function getCookie (c_name) {
        var i,
            x,
            y,
            ARRcookies = document.cookie.split(';');

        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
            x = x.replace(/^\s+|\s+$/g, '');
            if (x == c_name) {
                return unescape(y);
            }
        }
    }

    function deleteCookie (name){
        setCookie(name,'',-1);
    }

})();

Object.freeze(StorageService);
